import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

const AnalyticBlockMenu = ({ children }: PropsWithChildren): ReactElement => {
  return <div className="analytics-block-menu">{children}</div>
}

export default AnalyticBlockMenu
